// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__9EQs1","header":"PatientBlock_header__2hOIw","label":"PatientBlock_label__3LvnY","option":"PatientBlock_option__27RVT"};